import { withStylePrefix } from '../common/withStylePrefix';
import { ScrollBoxComponent, scrollBoxTemplate } from './ScrollBox';
import styles from './ScrollBox.styles.scss';
export const scrollBoxDefinition = {
    baseName: 'scroll-box',
    template: scrollBoxTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonScrollBox = ScrollBoxComponent.compose(scrollBoxDefinition);
